import React, { ReactElement, useState } from 'react';
import { TileLayer } from 'react-leaflet';
import { Place } from '../../models/Place';
import 'leaflet/dist/leaflet.css';
import { LatLng } from 'leaflet';
import { MapContainerStyled } from './mapStyles';
import 'leaflet-polylinedecorator';
import { useIonViewDidEnter } from '@ionic/react';
import { PlaceList } from '../../models/factories/PlaceFactory';
import { AONB_Bounds } from '../../application/config';
import MapController from '../Mapping/MapController';
import LocationMarker from '../Mapping/LocationMarker';
import MapHomeButton from '../Mapping/MapHomeButton';
import PlaceMarkers from '../Mapping/PlaceMarkers';
import MapToasts from '../Global/DumbMap/subComponents/MapToasts/MapToasts';

type MapProps = {
	center?: LatLng;
	auto_bounds?: boolean;
	place_list: PlaceList;
};

function GlobalMap({
	center = undefined,
	auto_bounds = true,
	place_list,
}: MapProps): ReactElement {
	const [showToasts, setShowToasts] = useState(false);
	const [clusterToasts, setClusterToasts] = useState(false);
	const [activePlaces, setActivePlaces] = useState<Place[]>([]);

	useIonViewDidEnter(() => {
		window.dispatchEvent(new Event('resize'));
	});

	const clusterClickHandler = (theActivePlace: Place) => {
		console.log('Handler', theActivePlace);
		setActivePlaces([theActivePlace]);
		setShowToasts(true);
		setClusterToasts(false);
		return {};
	};

	return (
		<>
			<MapContainerStyled
				id="globalMap"
				className="fullMap"
				center={center ?? AONB_Bounds.getCenter()}
				zoom={14}
				scrollWheelZoom={true}
				attributionControl={false}>
				<>
					<MapController
						places={place_list.places}
						autoFitBounds={auto_bounds}
						setShowToasts={setShowToasts}
					/>
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					{/*<Rectangle bounds={AppData.boundary} />*/}
					<LocationMarker />
					<PlaceMarkers
						places={place_list.places}
						clickHandler={clusterClickHandler}
					/>
					<MapHomeButton />
				</>
			</MapContainerStyled>
			<MapToasts
				clusterToasts={clusterToasts}
				showToasts={showToasts}
				places={activePlaces}
			/>
		</>
	);
}

export default GlobalMap;
